import { useState } from 'react'
import {
  Grid,
  TextField,
  Button,
  CircularProgress,
  Box,
} from '@material-ui/core'
import { Add as AddIcon } from '@material-ui/icons'

import { Controller, useForm } from 'react-hook-form'
import { useSnackbar, useFetch } from 'hooks'

import { Card, MenuButton } from 'components'
import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from 'components/Table'

import helpers from 'helpers'
import useStyles from './styles'

import * as service from 'service'

const BillingEmails = ({ disabled, paymentContractId }) => {
  const snackbar = useSnackbar()
  const classes = useStyles()
  const [loading, setLoading] = useState(false)

  const { control, handleSubmit, errors, reset } = useForm({
    defaultValues: {
      email: '',
    },
  })

  const { response, isLoading, refresh } = useFetch(
    service.dponet.billingEmails.index,
    {
      entityIdEq: paymentContractId,
      entityTypeEq: 'PaymentContract',
    },
    [],
  )

  const billingEmails = (!isLoading && response?.data?.billingEmails) || []

  const onSubmit = async (data) => {
    setLoading(true)
    try {
      await service.dponet.billingEmails.create({
        paymentContractId,
        email: data.email.toLowerCase(),
      })

      snackbar.open({
        message: 'E-mail de pagamento e cobrança adicionado com sucesso!',
        variant: 'success',
      })
      reset()
      refresh()
    } catch (error) {
      snackbar.open({
        message: helpers.formatters.errorMessage(
          error?.response?.data?.error ||
            'Falha ao adicionar o e-mail de cobrança',
        ),
        variant: 'error',
      })
    } finally {
      setLoading(false)
    }
  }

  const handleEmailKeyDown = (event) => {
    if (event.key !== 'Enter') return

    event.preventDefault()
    event.stopPropagation()
    handleSubmit(onSubmit)()
  }

  const handleRemove = async (billingEmailId) => {
    setLoading(true)
    try {
      await service.dponet.billingEmails.destroy(billingEmailId)

      snackbar.open({
        message: 'E-mail de pagamento e cobrança excluído com sucesso!',
        variant: 'success',
      })

      refresh()
    } catch (error) {
      snackbar.open({
        message: helpers.formatters.errorMessage(
          error?.response?.data?.error ||
            'Falha ao excluir o e-mail de cobrança',
        ),
        variant: 'error',
      })
    } finally {
      setLoading(false)
    }
  }

  return (
    <Card title="E-mails de notificações">
      <Box mb={2}>
        <Grid container spacing={2}>
          {!disabled && (
            <>
              <Grid item xs={10}>
                <Controller
                  control={control}
                  name="email"
                  mode="onChange"
                  as={
                    <TextField
                      type="email"
                      label="Emails de cobrança"
                      fullWidth
                      variant="outlined"
                      error={!!errors?.email}
                      helperText={errors?.email?.message}
                      disabled={loading}
                      onKeyDown={handleEmailKeyDown}
                    />
                  }
                />
              </Grid>
              <Grid item xs={2}>
                <Button
                  type="Button"
                  fullWidth
                  className={classes.btn}
                  startIcon={
                    loading ? (
                      <CircularProgress color="white" size={20} />
                    ) : (
                      <AddIcon />
                    )
                  }
                  disabled={loading}
                  variant="contained"
                  color="primary"
                  onClick={handleSubmit(onSubmit)}
                >
                  Adicionar
                </Button>
              </Grid>
            </>
          )}
        </Grid>
      </Box>
      <Table size="small" stickyHeader isLoading={isLoading}>
        <TableHead>
          <TableRow>
            <TableCell width="20%">Identificador</TableCell>
            <TableCell width="60%">E-mail</TableCell>
            <TableCell width="20%" align="right">
              Ações
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {billingEmails?.map((emailObject) => (
            <TableRow hover key={emailObject?.id}>
              <TableCell disableTooltip>{emailObject?.id}</TableCell>
              <TableCell noOverFlow>{emailObject?.email}</TableCell>
              <TableCell disableTooltip align="right">
                <MenuButton>
                  <Button
                    onClick={() => handleRemove(emailObject?.id)}
                    fullWidth
                    size="small"
                    disabled={disabled}
                  >
                    Excluir
                  </Button>
                </MenuButton>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Card>
  )
}

export default BillingEmails
